import { Controller } from "@hotwired/stimulus"
import { debounce, deleteStream, patchJson, patchStream, postStream, sessionIdFor } from "./sweeper_shared"

export default class extends Controller {
  update(event) {
    const field = event.target.closest("[data-cm]")
    if (!field || !this.sessionId) return

    const index = field.dataset.idx
    debounce(this, `countermeasure:${index}:${field.dataset.cm}`, () => {
      patchJson(`/api/v1/sessions/${encodeURIComponent(this.sessionId)}/countermeasure/${index}`, {
        [field.dataset.cm]: field.value
      })
    })
  }

  add(event) {
    if (event && !event.target.closest('[data-editor-action="add-cm"]')) return
    if (!this.sessionId) return

    postStream(`/api/v1/sessions/${encodeURIComponent(this.sessionId)}/countermeasure`, {
      risk: "",
      move: "",
      trigger: ""
    })
  }

  remove(event) {
    const button = event.target.closest("[data-cm-del]")
    if (!button || !this.sessionId) return

    deleteStream(`/api/v1/sessions/${encodeURIComponent(this.sessionId)}/countermeasure/${button.dataset.cmDel}`)
  }

  get sessionId() {
    return sessionIdFor(this.element)
  }
}
